import api from '@/api/axios';
import { API_ENDPOINTS } from '@/api/endpoints';
import type { MyUnreadMail } from '../types';

/** The Java ApiResponse puts the payload in Data1. */
const unwrap = <T>(payload: unknown): T => {
  if (payload && typeof payload === 'object') {
    const box = payload as Record<string, unknown>;
    if ('Data1' in box) return box.Data1 as T;
    if ('data1' in box) return box.data1 as T;
  }
  return payload as T;
};

export const myUnreadApi = {
  mine: async (companyId: number): Promise<MyUnreadMail> => {
    const response = await api.get(API_ENDPOINTS.MAIL_MONITOR.MY_UNREAD, { params: { companyId } });
    return unwrap<MyUnreadMail>(response.data);
  },
};
